import { AxiosError } from "axios";
import { getErrorMessage } from "utils/error";

const OWNER_LEAD_CANNOT_HAVE_PROPERTY =
  "Owner leads can't be linked to a property or unit. Remove the property/unit selection before saving.";
const OWNER_LEADS_FEATURE_DISABLED =
  "The Owner Leads feature is not enabled for this partner. Contact your admin to enable it.";

/**
 * Maps the two owner-lead-specific backend failures to friendly copy, falling
 * back to the generic extractor for everything else. The feature-gate 403 has
 * no error code, so it's only surfaced for owner operations to avoid mislabeling
 * an unrelated permission 403 on the shared create/update flow.
 */
export const getLeadMutationErrorMessage = (
  error: unknown,
  { isOwnerLead = false }: { isOwnerLead?: boolean } = {}
): string => {
  if (error instanceof AxiosError) {
    if (isOwnerLead && error.response?.status === 403)
      return OWNER_LEADS_FEATURE_DISABLED;
    if (error.response?.data?.error?.code === "owner_lead_cannot_have_property")
      return OWNER_LEAD_CANNOT_HAVE_PROPERTY;
  }
  return getErrorMessage(error);
};
